(function($) {

  Drupal.behaviors.aerin_woa_blog_formatter = {
    attach: function(context, settings) {
      $('body').addClass('brand-aerin');
    } // attach
  };

})(jQuery);
